/**
 * Passos do wizard do TOTEM (autoatendimento), por nome. Pager e "CPF na nota" entram
 * condicionalmente — a loja pode não usar localizador nem emitir NFC-e, e aí o wizard
 * não muda de tamanho.
 */
export type PassoTotem = 'CONSUMO' | 'IDENTIFICACAO' | 'PAGER' | 'CPF_NOTA' | 'PAGAMENTO' | 'CONFIRMACAO';

export const ROTULO_PASSO_TOTEM: Record<PassoTotem, string> = {
  CONSUMO: 'Consumo',
  IDENTIFICACAO: 'Identificação',
  PAGER: 'Pager',
  CPF_NOTA: 'CPF na nota',
  PAGAMENTO: 'Pagamento',
  CONFIRMACAO: 'Confirmação',
};

export function passosDoTotem(usaPager: boolean, perguntaCpfNota: boolean): PassoTotem[] {
  return [
    'CONSUMO',
    'IDENTIFICACAO',
    ...(usaPager ? (['PAGER'] as const) : []),
    ...(perguntaCpfNota ? (['CPF_NOTA'] as const) : []),
    'PAGAMENTO',
    'CONFIRMACAO',
  ];
}

/** Com pager o pedido sai no passo do pagamento, sem a confirmação — comportamento anterior, mantido. */
export function ultimoPassoDoTotem(passos: PassoTotem[], usaPager: boolean): number {
  return passos.indexOf(usaPager ? 'PAGAMENTO' : 'CONFIRMACAO');
}

/** Resposta do passo "CPF na nota"; `null` enquanto o cliente não respondeu. */
export type RespostaCpfNota = { incluir: boolean; cpf: string } | null;

/**
 * CPF que vai no pedido. Com a pergunta, vale a resposta: "Não" manda o pedido sem CPF, mesmo
 * com CPF na identificação — no Sischef o CPF do cliente vira o destinatário da NFC-e.
 */
export function cpfDoPedidoTotem(
  perguntaCpfNota: boolean,
  resposta: RespostaCpfNota,
  cpfIdentificacao: string,
): string | undefined {
  if (!perguntaCpfNota || resposta === null) return cpfIdentificacao.trim() || undefined;
  return resposta.incluir ? resposta.cpf || undefined : undefined;
}
